import { useEffect } from "react";

const GoogleTranslate = () => {
  useEffect(() => {
    // Prevent loading the script multiple times
    if (window.google?.translate || document.getElementById("google-translate-script")) return;

    // Define the callback before loading the script
    window.googleTranslateElementInit = function () {
      try {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: "en",
            layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
          },
          "google_translate_element"
        );
      } catch (e) {
        console.warn("Google Translate failed to initialize:", e);
      }
    };

    const script = document.createElement("script");
    script.id = "google-translate-script";
    script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.async = true;
    script.onerror = () => {
      console.warn("Google Translate script failed to load.");
    };
    document.body.appendChild(script);
  }, []);

  return (
    <div
      id="google_translate_element"
      style={{ position: "fixed", top: 10, right: 10, zIndex: 9999 }}
    ></div>
  );
};

export default GoogleTranslate;
